import React from 'react';
import {GetAccess} from "../../components";

const Access = () => {
    return <GetAccess/>
};

export default Access;